<!--
 * @Date: 2020-08-14 09:53:12
 * @Author: zhangsong
 * @Description: description
-->
<template>
  <div class="image-name">
    <img class="image" :src="image" />
    <div class="name">{{name}}</div>
    <div class="name">{{code}}</div>
  </div>
</template>

<script>
export default {
  name: "ImageAndName",
  props: ["image", "name","code"]
};
</script>

<style lang="less" scoped>
.image-name {
  height: 60px;
  // width: 300px;
  text-align: left;
  .image {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    display: inline-block;
    vertical-align: top;
    margin: 6px 0;
  }
  .name {
    // width: 200px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    display: inline-block;
    line-height: 60px;
    vertical-align: top;
    margin-left: 10px;
  }
}
</style>

